exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VueCarousel-slide-center[data-v-37dc1333] {\n  opacity: 1\n}\n", ""]);

// exports
